import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Dashboard, Login } from "./screens";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Dashboard />
        </Route>

        <Route path="/login">
          <Login />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
